import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function ProductsPreview() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        let cancelled = false;
        fetchProducts({}).then((data) => {
            if (!cancelled) setItems(data.slice(0, 6));
        }).catch(() => {});
        return () => { cancelled = true; };
    }, []);

    return (
        <section id="products" className="py-20 lg:py-28 bg-white" data-testid="products-preview-section">
            <div className="container-lg">
                <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-10">
                    <div>
                        <span className="text-xs font-bold tracking-[0.24em] uppercase text-brand">Products</span>
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy">
                            Enterprise-grade networking<br />hardware, in stock.
                        </h2>
                    </div>
                    <Link
                        to="/products"
                        data-testid="products-preview-view-all"
                        className="inline-flex items-center gap-2 rounded-full bg-navy text-white px-5 py-3 text-sm font-semibold hover:bg-brand transition-colors"
                    >
                        Explore Catalog <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {items.map((p) => (
                        <ProductCard key={p.id} product={p} />
                    ))}
                </div>
            </div>
        </section>
    );
}
